import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  trigger: FelaCSS;
}

const styles: IStyles = {
  trigger: {
    cursor: 'pointer',
    padding: 1,
  },
};

export default styles;
